/**
 * Brand Capitalization Rules
 * 
 * Complete list of all 438 brand names with correct capitalization.
 * Source of truth: docs/Design.md
 * 
 * Last Updated: 2025-10-18
 */

export const BRAND_RULES: Record<string, string> = {
  // A
  // NOTE: 'AI Fridges' removed - this is a product type/category, not a brand
  'aobosi': 'Aobosi',
  'abrahams': 'Abrahams',
  'acem': 'ACEM',
  'acopower': 'ACOPOWER',
  'adrinfly': 'Adrinfly',
  'adt': 'ADT',
  'aj madison': 'AJ Madison',
  'alera': 'Alera',
  'alfresco': 'Alfresco',
  'allavino': 'Allavino',
  'amana': 'Amana',
  'american outdoor grill': 'American Outdoor Grill',
  'ancaster food equipment': 'Ancaster Food Equipment',
  'antarctic star': 'Antarctic Star',
  'antfurniture': 'AntFurniture',
  'aoibox': 'AOIBOX',
  'aplancee': 'Aplancee',
  'aqua optima': 'Aqua Optima',
  'aquverse': 'Aquverse',
  'arctic king': 'Arctic King',
  'arctic wind': 'Arctic Wind',
  'artisan': 'Artisan',
  'artist hand': 'Artist Hand',
  'artudatech': 'Artudatech',
  'astroai': 'AstroAI',
  'aula': 'AULA',
  'avallon': 'Avallon',
  'avalon': 'Avalon',
  'avanti': 'Avanti',
  'azure home products': 'Azure Home Products',
  
  // B
  'babevy': 'Babevy',
  'batman': 'Batman',
  'beer meister': 'Beer Meister',
  'beko': 'Beko',
  'bentism': 'Bentism',
  'bertazzoni': 'Bertazzoni',
  'bev-air': 'Beverage Air',
  'beverage air': 'Beverage Air',
  'beverage-air': 'Beverage Air',
  'bevoi': 'BEVOI',
  'bfgoodrich': 'BFGoodrich',
  'black decker': 'Black+Decker',
  'black+decker': 'Black+Decker',
  'black-decker': 'Black+Decker',
  'blackdecker': 'Black+Decker',
  'blaze grills': 'Blaze Grills',
  'blomberg': 'Blomberg',
  'bodare': 'Bodare',
  'bodega': 'BODEGA',
  'bodega cooler': 'BODEGA',
  'bosch': 'Bosch',
  'boshen': 'Boshen',
  'bougerv': 'BougeRV',
  'brama': 'Brama',
  'brio': 'Brio',
  'brita': 'Brita',
  'broil king': 'Broil King',
  'bruce shark': 'Bruce Shark',
  'bud light': 'Bud Light',
  'bull outdoor products': 'Bull Outdoor Products',
  
  // C
  'cafe': 'Café',
  'cafe appliances': 'Café Appliances',
  'calefort': 'Calefort',
  'call of duty': 'Call of Duty',
  'camco': 'Camco',
  'carlisle': 'Carlisle',
  'caso': 'Caso',
  'caso design': 'Caso Design',
  'casodesign': 'Caso Design',
  'caynel': 'Caynel',
  'char broil': 'Char-Broil',
  'char-broil': 'Char-Broil',
  'charbroil': 'Char-Broil',
  'chefman': 'Chefman',
  'cheri bliss': 'Cheri Bliss',
  'cismea': 'CISMEA',
  'class design home': 'Class Design Home',
  'clf': 'CLF',
  'cna international': 'CNA International',
  'cncest': 'CNCEST',
  'coca cola': 'Coca-Cola',
  'coca-cola': 'Coca-Cola',
  'colozo': 'Colzer',
  'colzer': 'Colzer',
  'comfee': "COMFEE'",
  'conserv': 'Conserv',
  'continental refrigeration': 'Continental Refrigerator',
  'continental refrigerator': 'Continental Refrigerator',
  'cooler depot': 'Cooler Depot',
  'coolski': 'COOLSKI',
  'cooluli': 'Cooluli',
  'coors light': 'Coors Light',
  'corona': 'Corona',
  'cosmo': 'Cosmo',
  'costway': 'COSTWAY',
  'cosvalve': 'Cosvalve',
  'cotlin': 'Cotlin',
  'cowsar': 'Cowsar',
  'coyote grills': 'Coyote Grills',
  'cozypony': 'Cozypony',
  'crosley': 'Crosley',
  'crownful': 'CROWNFUL',
  'cuisinart': 'Cuisinart',
  
  // D
  'dacor': 'Dacor',
  'danby': 'Danby',
  'dash': 'DASH',
  'deco chef': 'Deco Chef',
  'demuller': 'Demuller',
  'domccy': 'Domccy',
  'dominty': 'DomintY',
  'dr pepper': 'Dr Pepper',
  'drinkpod': 'Drinkpod',
  'dukers appliance': 'Dukers Appliance',
  'dundee deco': 'Dundee Deco',
  
  // E
  'edgestar': 'EdgeStar',
  'electrolux': 'Electrolux',
  'eleoption': 'Eleoption',
  'elexnux': 'ELEXNUX',
  'elica': 'Elica',
  'elisii': 'Elisii',
  'elite kitchen supply': 'Elite Kitchen Supply',
  'elkay': 'Elkay',
  'emerson': 'Emerson',
  'empava': 'Empava',
  'energy star': 'ENERGY STAR',
  'engindot': 'ENGiNDOT',
  'equator': 'Equator',
  'erivess': 'Erivess',
  'erommy': 'Erommy',
  'eshoo': 'Eshoo',
  'eternal': 'Eternal',
  'euhomy': 'Euhomy',
  'euker': 'EUKER',
  
  // F
  'famyyt': 'FAMYYT',
  'fanta': 'Fanta',
  'farberware': 'Farberware',
  'fashionwu': 'Fashionwu',
  'fc design': 'FC Design',
  'fdfk': 'FDFK',
  'fisher paykel': 'Fisher & Paykel',
  'fisher & paykel': 'Fisher & Paykel',
  'fixturedisplays': 'FixtureDisplays',
  'forclover': 'Forclover',
  'ford': 'Ford',
  'forno': 'Forno',
  'forte': 'Forte',
  'frestec': 'Frestec',
  'frigidaire': 'Frigidaire',
  'frigidaire usa': 'Frigidaire USA',
  'frostronics': 'Frostronics',
  'furnimics': 'Furnimics',
  
  // G
  'gaggenau': 'Gaggenau',
  'galanz': 'Galanz',
  'galanz retro': 'Galanz Retro',
  'gaomon': 'GAOMON',
  'garvee': 'Garvee',
  'ge': 'GE',
  'ge appliances': 'GE Appliances',
  'ge cafe': 'GE Café',
  'ge café': 'GE Café',
  'ge profile': 'GE Profile',
  'geek chef': 'Geek Chef',
  'genuine joe': 'Genuine Joe',
  'giantex': 'Giantex',
  'gindexis': 'Gindexis',
  'glacier bay': 'Glacier Bay',
  'gladiator': 'Gladiator',
  'global water': 'Global Water',
  'glowsol': 'Glowsol',
  'gunji': 'GUNJI',
  'gymax': 'Gymax',
  
  // H
  'haier': 'Haier',
  'hallman': 'Hallman',
  'hamilton beach': 'Hamilton Beach',
  'hanover': 'Hanover',
  'harry potter': 'Harry Potter',
  'hck': 'HCK',
  'hello kitty': 'Hello Kitty',
  'hestan': 'Hestan',
  'high life': 'High Life',
  'himimi': 'Himimi',
  'hisense': 'Hisense',
  'hispania home': 'Hispania Home',
  'homcom': 'HOMCOM',
  'homdox': 'Homdox',
  'homecraft': 'HomeCraft',
  'homevision technology': 'Homevision Technology',
  'homhou go': 'HOMHOU GO',
  'homhougo': 'HOMHOU GO',
  'honeywell': 'Honeywell',
  'hoomic': 'Hoomic',
  'hoshizaki': 'Hoshizaki',
  'hoshizaki america': 'Hoshizaki',
  'hooure': 'Hooure',
  'hossejoy': 'Hossejoy',
  'hotpoint': 'Hotpoint',
  'huashu': 'Huashu',
  'husky': 'Husky',
  
  // I
  'icejungle': 'ICEJUNGLE',
  'iceman': 'Iceman',
  'icon beauty': 'Icon Beauty',
  'igloo': 'Igloo',
  'iio': 'iio',
  'ikkle': 'IKKLE',
  'ikt': 'IKT',
  'impecca': 'Impecca',
  'ionchill': 'IONCHILL',
  'iseasy': 'Iseasy',
  'itou': 'Itou',
  'ivation': 'Ivation',
  
  // J
  'jennair': 'JennAir',
  'jenn air': 'JennAir',
  'jeremy cass': 'Jeremy Cass',
  'joyding': 'Joyding',
  
  // K
  'kalafun': 'Kalafun',
  'kalamera': 'Kalamera',
  'karl home': 'Karl Home',
  'kegco': 'Kegco',
  'kelivol': 'Kelivol',
  'kenmore': 'Kenmore',
  'keystone': 'Keystone',
  'khoola': 'Khoola',
  'kichking': 'KichKing',
  'kingsbottle': 'KingsBottle',
  'kitchenaid': 'KitchenAid',
  'kitchen aid': 'KitchenAid',
  'koblenz': 'Koblenz',
  'koolatron': 'Koolatron',
  'koolmore': 'KoolMore',
  'kozart': 'Kozart',
  'krib bling': 'Krib Bling',
  'ktaxon': 'Ktaxon',
  'kucht': 'Kucht',
  'kuppet': 'KUPPET',

  // L
  'lanbopro': 'LANBOPRO',  // All caps, no space
  'lanbo': 'LANBO',  // All caps
  'lcaoful': 'LCAOFUL',
  'leka': 'LEKA',
  'lg': 'LG',
  'linkewode': 'LinkeWode',
  'lion premium grills': 'Lion Premium Grills',
  'little luxury': 'Little Luxury',
  'loochmee': 'Loochmee',
  'lorell': 'Lorell',
  'loveiscool': 'LOVEISCool',
  'luckyremore': 'Luckyermore',
  'luckyermore': 'Luckyermore',
  'luma comfort': 'Luma Comfort',
  'lumisol': 'Lumisol',
  'lynx': 'Lynx',

  // M
  'magic chef': 'Magic Chef',
  'magic cool': 'Magic Cool',
  'marshall fridges': 'Marshall Fridges',
  'maxx ice': 'Maxx Ice',
  'maytag': 'Maytag',
  'megachef': 'MegaChef',
  'michelin': 'Michelin',
  'midea': 'Midea',
  'miele': 'Miele',
  'miller lite': 'Miller Lite',
  'minecraft': 'Minecraft',
  'miroco': 'Miroco',
  'mist': 'Mist',
  'modelo': 'Modelo',
  'modernluxe': 'ModernLuxe',
  'mojgar': 'MOJGAR',
  'monogram': 'Monogram',
  'monogram appliances': 'Monogram Appliances',
  'mont alpi': 'Mont Alpi',
  'mountain dew': 'Mountain Dew',

  // N
  // FRIDGE-641 (08/29/2026): 'Nafcoool' was a propagated TYPO — the brand's
  // own site (nafcool.com) styles it NAFCOOL. The typo key stays as a synonym
  // so any residue still normalizes to the correct form.
  'nafcool': 'NAFCOOL',
  'nafcoool': 'NAFCOOL',
  'nanan': 'NANAN',
  'naruto': 'Naruto',
  'newair': 'NewAir',
  'nfl': 'NFL',
  'nipus': 'NIPUS',
  'norbi': 'NORBI',
  'norpole': 'Norpole',
  'northair': 'Northair',
  'northland': 'Northland',
  'northlight seasonal': 'Northlight Seasonal',
  'nostalgia': 'Nostalgia',
  'nutrichef': 'NutriChef',

  // O
  'onewell': 'Onewell',
  'orbit innovations': 'Orbit Innovations',
  'orgo': 'Orgo',
  'orren ellis': 'Orren Ellis',
  'oukaning': 'OUKANING',
  'outsunny': 'Outsunny',
  'oylus': 'Oylus',

  // P
  'panasonic': 'Panasonic',
  'pepsi': 'Pepsi',
  'perlick': 'Perlick',
  'permasteel': 'Permasteel',
  'personal chiller': 'Personal Chiller',
  'phiestina': 'Phiestina',
  'plotanis': 'Plotanis',
  'polar bear': 'Polar Bear',
  'premium levella': 'Premium Levella',
  'prep savour': 'Prep & Savour',
  'prep & savour': 'Prep & Savour',
  'primo': 'Primo',

  // R
  'r w flame': 'R.W.FLAME',
  'r.w.flame': 'R.W.FLAME',
  'raen': 'Raen',
  'rays': 'Rays',
  'rca': 'RCA',
  'rhomeway': 'Rhomeway',
  'ropup': 'Ropup',
  'rovrak': 'Rovrak',
  'rv': 'RV',  // Recreational Vehicle - always uppercase

  // S
  'saba': 'SABA',
  'saber': 'Saber',
  'samsung': 'Samsung',
  'schmecke': 'Schmécke',
  'schmécke': 'Schmécke',
  'scotsman': 'Scotsman',
  'sharp': 'Sharp',
  'silhouette': 'Silhouette',
  'silhouette appliances': 'Silhouette',
  'silonn': 'Silonn',
  'simzlife': 'Simzlife',
  'skyshalo': 'Skyshalo',
  'smartfridge by minibar systems': 'SmartFridge by Minibar Systems',
  'smeg': 'Smeg',
  'smith hanks': 'Smith & Hanks',
  'smith & hanks': 'Smith & Hanks',
  'smugdesk com': 'Smugdesk.com',
  'smugdesk.com': 'Smugdesk.com',
  'sollevare': 'Sollevare',
  'soopyk': 'SOOPYK',
  'sotola': 'SOTOLA',
  'spa sciences': 'Spa Sciences',
  'sprite': 'Sprite',
  'spt': 'SPT',
  'staigis': 'Staigis',
  'sub zero': 'Sub-Zero',
  'sub-zero': 'Sub-Zero',
  'subzero': 'Sub-Zero',
  'summerset': 'Summerset',
  'summit': 'Summit',
  'summit appliance': 'Summit Appliance',
  'sunnydaze': 'Sunnydaze',
  'sunyou': 'SUNYOU',
  'symple stuff': 'Symple Stuff',

  // T
  'tabu': 'Tabu',
  'tazpi': 'Tazpi',
  'tcl': 'TCL',
  'tcmt': 'TCMT',
  'tectron': 'Tectron',
  'thermador': 'Thermador',
  'thermostar': 'ThermoStar',
  'thomson': 'Thomson',
  'thor kitchen': 'THOR Kitchen',
  'tiramisubest': 'Tiramisubest',
  'titan': 'Titan',
  'tittla': 'Tittla',
  'toocapro': 'Toocapro',
  'total chef': 'Total Chef',
  'trifecte': 'Trifecte',
  'true': 'True',
  'true manufacturing': 'True',
  'true mfg': 'True',
  'true refrigeration': 'True',
  'trustmade': 'Trustmade',
  'turbo air': 'Turbo Air',
  'turboair': 'Turbo Air',

  // U
  'u line': 'U-Line',
  'u-line': 'U-Line',
  'uber appliance': 'Uber Appliance',
  'unique appliances': 'Unique Appliances',
  'upstreman': 'Upstreman',

  // V
  'velivi': 'Velivi',
  'vevor': 'VEVOR',
  'victorim': 'Victorim',
  'viking': 'Viking',
  'vinkko': 'Vinkko',
  'vinotemp': 'Vinotemp',
  'vinsunny': 'Vinsunny',
  'vintec': 'Vintec',
  'vissani': 'Vissani',
  'vitafilta': 'VitaFilta',
  'vitapur': 'Vitapur',
  'vitara': 'Vitara',
  'vivohome': 'VIVOHOME',

  // W
  'wade logan': 'Wade Logan',
  'wanai': 'WANAI',
  'wandor': 'Wandor',
  'west bend': 'West Bend',
  'westbrass': 'Westbrass',
  'whirlpool': 'Whirlpool',
  'whynter': 'Whynter',
  'wildon home': 'Wildon Home',
  'willz': 'Willz',
  'winado': 'Winado',
  'wine enthusiast': 'Wine Enthusiast',
  'wine mate': 'Wine-Mate',
  'wine-mate': 'Wine-Mate',
  'winia': 'Winia',
  'wtressa': 'Wtressa',
  'wukhg': 'WUKHG',

  // X
  'xbox': 'Xbox',
  'xo appliance': 'XO Appliance',
  'xppliance': 'Xppliance',
  'xspracer': 'Xspracer',

  // Y
  'yeego': 'YEEGO',
  'yesurprise': 'Yesurprise',
  'yinxier': 'Yinxier',
  'yukool': 'YUKOOL',
  'yxsun': 'YXSUN',

  // Z
  'zephyr': 'Zephyr',
  'zline': 'ZLINE',
  'zokop': 'ZOKOP',
  'zsa': 'ZSA',
  'zstar': 'ZSTAR',
}

/**
 * Unit ABBREVIATIONS and their correct casing — the exception list the
 * title-caser consults so a measurement is never re-cased into a word
 * (FRIDGE-134 residual, found live 08/17/2026: "21.9 Cuft", "45 Db",
 * "350 kWh/Yr", "Frigidaire 30 In. 20.0 Cu. Ft.").
 *
 * Deliberately abbreviations only. Spelled-out unit words ("inch", "amp",
 * "volts", "pounds") read correctly title-cased inside a product name —
 * "36 Inch Counter Depth" is right, "20 Cu. Ft." is not — and the catalogue's
 * own feed titles carry them capitalised already, so lowercasing them would
 * be a change no evidence asks for.
 *
 * Casing here is the unit's real casing, not merely lowercase: "dB" and "Hz"
 * and "BTU" are as wrong in lowercase as they are title-cased.
 *
 * A token in this list is only treated as a unit when a NUMBER (or another
 * qualifying unit) immediately precedes it — see `isUnitInContext`. That is
 * what separates the unit "30 in." from the preposition in "refrigerator in
 * black", which appear in the same feed title.
 */
export const UNIT_TOKENS: Record<string, string> = {
  // Volume / capacity
  'cu': 'cu',
  'ft': 'ft',
  'cuft': 'cuft',
  'cf': 'cf',
  'ml': 'ml',
  'qt': 'qt',
  'qts': 'qts',
  'gal': 'gal',
  'oz': 'oz',
  'pt': 'pt',
  // Length
  'in': 'in',
  'mm': 'mm',
  'cm': 'cm',
  'sq': 'sq',
  // Mass
  'lb': 'lb',
  'lbs': 'lbs',
  'kg': 'kg',
  'mg': 'mg',
  // Energy / power / electrical
  'kwh': 'kWh',
  'wh': 'Wh',
  'kw': 'kW',
  'btu': 'BTU',
  'hz': 'Hz',
  'khz': 'kHz',
  'mah': 'mAh',
  // Sound
  'db': 'dB',
  'dba': 'dBA',
  // Pressure / rotation
  'psi': 'PSI',
  'rpm': 'RPM',
  // Time (the "/yr" half of "350 kWh/yr")
  'yr': 'yr',
  'yrs': 'yrs',
  'hr': 'hr',
  'hrs': 'hrs',
  'min': 'min',
  'sec': 'sec',
  'mo': 'mo',
}

export const SPECIAL_TERMS: Record<string, string> = {
  'flexzone': 'FlexZone',
  'wifi': 'WiFi',
  'kcup': 'K-Cup',
  'k-cup': 'K-Cup',
  'k cup': 'K-Cup',
  'inverter': 'Inverter',
  'instaview': 'InstaView',
  'ada': 'ADA',
  'usa': 'USA',
  'ada compliant': 'ADA Compliant',
  'ada compliance': 'ADA Compliance',
  
  // Acronyms - always uppercase
  'bbq': 'BBQ',
  'uk': 'UK',
  'led': 'LED',
  'kwh': 'kWh',  // kilowatt-hour - lowercase k, uppercase W and H
  
  // Apostrophe terms - prevent "Year'S" capitalization
  "new year's eve": "New Year's Eve",
  "new year's day": "New Year's Day",
  "new year's": "New Year's",
  "year's": "Year's",
  "mother's day": "Mother's Day",
  "father's day": "Father's Day",
  "valentine's day": "Valentine's Day",
  "st. patrick's day": "St. Patrick's Day",
  "st patrick's day": "St. Patrick's Day",
  "president's day": "President's Day",
  "presidents' day": "Presidents' Day",
  "veteran's day": "Veteran's Day",
  "veterans day": "Veterans Day",
  "thanksgiving": "Thanksgiving",
  "christmas": "Christmas",
  "halloween": "Halloween",
  "easter": "Easter",
  "labor day": "Labor Day",
  "memorial day": "Memorial Day",
  "independence day": "Independence Day",
  "black friday": "Black Friday",
  "cyber monday": "Cyber Monday",
}

/**
 * Apply brand capitalization rules to text
 * @param text - Text to apply brand rules to
 * @returns Text with correct brand capitalization
 */
export function applyBrandRules(text: string): string {
  if (!text) return ''

  let result = text

  // Sort brand rules by length (longest first) to match multi-word brands before single words
  // This ensures "lanbo pro" is matched before "lanbo"
  const sortedBrandRules = Object.entries(BRAND_RULES).sort((a, b) => b[0].length - a[0].length)

  // Apply brand rules (case-insensitive replacement)
  sortedBrandRules.forEach(([key, value]) => {
    // Escape special regex characters in the key
    const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const regex = new RegExp(`\\b${escapedKey}\\b`, 'gi')
    result = result.replace(regex, value)
  })

  // Apply special terms
  Object.entries(SPECIAL_TERMS).forEach(([key, value]) => {
    const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const regex = new RegExp(`\\b${escapedKey}\\b`, 'gi')
    result = result.replace(regex, value)
  })

  // Fix apostrophe-s capitalization (e.g., "Year'S" → "Year's")
  // In English, the letter after an apostrophe in possessives/contractions is always lowercase
  result = result.replace(/'S\b/g, "'s")

  return result
}

/**
 * Characters that may sit between a number and the unit it measures, or
 * between two halves of one unit: whitespace, the abbreviating period in
 * "cu. ft.", the hyphen in "24-in", the solidus in "kWh/yr", the plus in
 * "100+ lbs." (FRIDGE-144 ten-title sweep, 08/24/2026: one live title carries
 * that shape and zero carry the "N+ in <word>" counter-shape that could make
 * the preposition guard misread — both counts measured before widening), and
 * the non-breaking space some feed titles put before a unit.
 */
const UNIT_GAP = /[\s.\-/+ ]/

/**
 * The word token immediately before `offset` in `whole`, skipping only
 * `UNIT_GAP` characters. Returns null when anything else intervenes (a comma,
 * a quote, an open bracket) or when the token starts the string — in either
 * case there is no number for a unit to attach to.
 */
function precedingToken(whole: string, offset: number): string | null {
  let i = offset - 1
  while (i >= 0 && UNIT_GAP.test(whole[i])) i--
  if (i < 0) return null
  const end = i + 1
  while (i >= 0 && /\w/.test(whole[i])) i--
  const start = i + 1
  if (start === end) return null
  return whole.slice(start, end)
}

/**
 * Is `word` at `offset` a unit of measure rather than an ordinary word?
 *
 * True only when `word` is in `UNIT_TOKENS` AND what precedes it is either a
 * number ("30 in.", "21.9 cuft") or another unit that itself qualifies
 * ("20.0 cu. ft." — `ft` follows `cu`, and `cu` follows `20.0`; "kWh/yr" —
 * `yr` follows `kWh`, and `kWh` follows a number).
 *
 * The number requirement is the whole point. "in" is both a unit and the
 * commonest English preposition, and both appear in one live feed title:
 * "whirlpool 36 in. wide french door refrigerator in black 25 cu. ft." — the
 * first is a measurement, the second is not, and only the preceding token
 * tells them apart.
 */
export function isUnitInContext(word: string, offset: number, whole: string): boolean {
  if (!Object.prototype.hasOwnProperty.call(UNIT_TOKENS, word.toLowerCase())) return false
  let cursor = offset
  // Walk back through a chain of units ("ft" → "cu" → "20.0"); bounded by the
  // string, and each step moves strictly left, so it always terminates.
  for (let hops = 0; hops < 4; hops++) {
    const prev = precedingToken(whole, cursor)
    if (prev === null) return false
    if (/^\d[\d,.]*$/.test(prev)) return true
    if (!Object.prototype.hasOwnProperty.call(UNIT_TOKENS, prev.toLowerCase())) return false
    cursor = whole.lastIndexOf(prev, cursor - 1)
    if (cursor < 0) return false
  }
  return false
}

/** The stored casing for a unit token ("db" → "dB"). */
export function unitCasing(word: string): string {
  return UNIT_TOKENS[word.toLowerCase()] ?? word
}

/**
 * Unit abbreviations the catalogue writes unspaced, and the spaced form the rest
 * of the catalogue already uses (FRIDGE-372, last item).
 *
 * WHY THIS IS A NORMALISATION AND NOT A STYLE PREFERENCE — counted live on
 * 08/18/2026 over `products` where `status='active'`:
 *
 *     titles containing `cuft`            80
 *     titles containing `cu ft` / `cu. ft.`  1,801
 *
 * So the unspaced form is the minority by more than 20 to 1. These 80 titles are
 * the outliers against a convention the catalogue has already established, which
 * is what makes aligning them a consistency fix rather than a rewrite. The card
 * asked for `21.9 Cuft` → `cu ft`.
 *
 * An earlier pass deliberately left `cuft` alone and pinned that in
 * tests/product-title-unit-casing.test.ts — a reasonable call when the only
 * argument was wording. The count above is the new evidence that changes it, and
 * the assertion is re-pinned the other way rather than deleted.
 *
 * Applied ONLY in a unit context (a number in front), for the same reason as
 * every other rule here: without it, a product literally named "Cuft" — or any
 * word containing that sequence — would be rewritten.
 */
export const UNIT_SPACING: Record<string, string> = {
  'cuft': 'cu ft',
  'cufts': 'cu ft',
  'sqft': 'sq ft',
}

/**
 * Expand an unspaced unit abbreviation to the catalogue's spaced form. Returns
 * the input unchanged when there is nothing to expand, so callers can apply it
 * unconditionally after `unitCasing`.
 */
export function unitSpacing(word: string): string {
  return UNIT_SPACING[word.toLowerCase()] ?? word
}

